/* eslint react/prop-types: [2, { "skipUndeclared": true }] */

import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { buildThumbnailUrl, Truncate, SanitizeHtml } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import SchoolList from '@bd/bdui-schoollist';
import LightBox from '@bd/bdui-lightbox';
import { CompareTable } from '@bd/bdui-compare';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuFind from '../../components/MenuFind';

const styles = css`
  .CompareTable_tableWrapper {
    max-width: 100%;
    overflow: scroll;
    position: relative;
    -webkit-overflow-scrolling: touch;
  }
  .CompareTable_tableBody .CompareTable_tableHeader {
    position: sticky;
    left: 0;
    background: ${colors.white};
    border-right: 1px solid ${colors.neutral};
    z-index: 10;
  }
  .CompareTable_table {
    position: relative;
    border: 1px solid ${colors.neutral};
    padding: 20px 0;
    .CompareTable_tableRow {
      & + .CompareTable_tableRow {
        border-top: 1px solid ${colors.neutral};
      }
    }
    .CompareTable_tableHeader {
      width: 250px;
      background-color: ${colors.whiteDark};
      padding: 20px;
      border-right: 1px solid ${colors.neutral};
      vertical-align: top;
      z-index: 0;
    }
    .CompareTable_tableData {
      width: 342px;
      max-width: 342px;
      min-width: 342px;
      padding: 15px;
      vertical-align: top;

      & + .CompareTable_tableData {
        border-left: 1px solid ${colors.neutral};
      }
      & div:first-of-type {
        position: relative;
      }
      .Compare_image {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 342px;
          height: 190px;
          object-fit: cover;
        }
      }
      .Compare_itemNumber {
        position: absolute;
        top: 0;
        left: 0;
        font-weight: 800;
        font-size: 20px;
        color: ${colors.white};
        letter-spacing: 0;
        background-color: ${colors.black};
        padding: 4px 10px;
        z-index: 1;
      }
      span {
        font-weight: 400;
        font-size: 16px;
        line-height: 23px;
      }
      div {
        font-weight: 700;
        font-size: 16px;
        line-height: 23px;
      }
      .SchoolList_list {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          padding: 7px 0;
        }
      }
      .LightBox_button {
        position: relative;
        padding-left: 28px;
        &::before {
          content: '';
          background-image: url('/images/compare-photos.svg');
          background-repeat: no-repeat;
          background-size: 20px 17px;
          position: absolute;
          left: 0;
          top: 0;
          width: 20px;
          height: 17px;
        }
      }
      .Compare_itemToggle {
        position: absolute;
        top: 8px;
        right: 10px;
        border-radius: 5px;
        width: 22px;
        height: 22px;
        background-repeat: no-repeat;
        background-image: url(/images/compare-close.svg);
        background-size: 20px 20px;
        cursor: pointer;
        z-index: 1;
      }
    }
  }
  .Compare_planLink {
    padding: 5px;
    white-space: no-wrap;
    float: left;
  }
  .Compare_communityLink {
    display: block;
    margin-top: 15px;
  }
  .btn-link {
    padding: 0;
    background-color: transparent;
    color: ${colors.body};
    border: none;
    text-transform: capitalize;
    font-weight: 700;
    background: none;
  }
  .CompareInsidePage_wrapper {
    height: 60px;
    padding: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: .25px solid ${colors.neutral};
    border-bottom: .25px solid ${colors.neutral};
    margin-top: 60px;
    @media(min-width: 992px) {
      height: 114px;
      margin-top: 0;
    }
    @media(min-width: 0\0) {
      .container {
        margin: 0;
      }
    }
    .InsideHeader_title {
      font-size: 17px;
      color: ${colors.black};
      letter-spacing: 1px;
      text-align: center;
      text-transform: uppercase;
      margin: 0;
      @media(min-width: 992px) {
        font-size: 40px;
        letter-spacing: 3.81px;
      }
    }
  }
  .CompareBody_copy {
    padding: 40px 20px;
    font-size: 22px;
    text-align: center;
    @media(min-width: 992px) {
      padding: 80px;
      font-size: 40px;
    }
  }
  .Compare_btn {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 218px;
    background-color: ${colors.brand1};
    font-weight: 700;
    text-transform: uppercase;
    font-size: 12px;
    color: ${colors.white};
    letter-spacing: 1.71px;
    text-align: center;
    line-height: 14px;
    z-index: 1;
    border-radius: 8px;
    transition: all .4s ease-out;
    min-width: 280px;
    @media(min-width: 992px) {
      height: 60px;
      max-width: 289px;
      font-size: 14px;
      letter-spacing: 2px;
      box-shadow: 0 15px 20px 0 rgba(0,0,0,0.50);
      position: relative;
    }
    &::after {
      content: '';
      border-left: 8px solid ${colors.black};
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      margin-left: 10px;
  }
    &:hover {
      transform: scale(1.03);
      transition: all .4s ease-out;
      @media(min-width: 992px) {
        background-color: ${colors.brand2Darkest};
      }
    }
  }
`;

function Compare({ builder, page, compare }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader page={page} />
      {
        get(builder, 'products.BDWebsiteCompare.isPurchased') &&
        (!get(compare, 'items').length || get(compare, 'items').length === 0) &&
        <div>
          <MenuFind />
          <div className="container">
            <div className="row justify-content-center">
              <div className="CompareBody_copy" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
            </div>
            <ul className="list-unstyled d-flex mb-5 flex-wrap justify-content-center">
              <li className="m-2 m-md-3">
                <Link name="communities" className="Compare_btn">Communities</Link>
              </li>
              <li className="m-2 m-md-3">
                <Link name="homes" className="Compare_btn">Homes</Link>
              </li>
              <li className="m-2 m-md-3">
                <Link name="plans" className="Compare_btn">Plans</Link>
              </li>
            </ul>
          </div>
        </div>
      }
      {
        get(compare, 'items').length > 0 &&
        <CompareTable
          title={({ compare: compareItems, config }) => (<div className="CompareInsidePage_wrapper"><h1 className="InsideHeader_title">{`Comparing ${get(config, `${get(compareItems, 'type')}.title`, 'Add Config Title')}`}</h1></div>)}
          config={{
            communities: {
              title: 'Communities',
              fields: [
                {
                  title: 'Community',
                  render: ({ item: community, index, toggle }) => (
                    <div>
                      <span className="Compare_itemNumber">#{index + 1}</span>
                      <span className="Compare_itemToggle" role="button" tabIndex="0" onClick={toggle} />
                      <div className="Compare_image CompareCommunity_image">
                        <img src={buildThumbnailUrl(get(community, 'logo.contentUrl'))} alt="" style={{ maxWidth: '100%' }} />
                      </div>
                      <Link className="Compare_communityLink" name="community-detail" community={community}>{get(community, 'name')}</Link>
                    </div>
                  ),
                },
                {
                  title: 'Address',
                  render: ({ item: community }) => (
                    <div>
                      {get(community, 'address.streetAddress', [])} <br />
                      {`${get(community, 'address.addressLocality', [])}, ${get(community, 'address.addressRegion', [])} ${get(community, 'address.postalCode', [])}`}
                    </div>
                  ),
                },
                {
                  title: 'Headline',
                  render: ({ item: community }) => (<span>{get(community, 'headline')}</span>),
                },
                {
                  title: 'Description',
                  render: ({ item: community }) => (<Truncate value={get(community, 'description')} nl2br />),
                },
                {
                  title: 'Price Range',
                  render: ({ item: community }) => (<span>{`${numeral(get(community, 'priceLow')).format('$0,0')} to ${numeral(get(community, 'priceHigh')).format('$0,0')}`}</span>),
                },
                {
                  title: 'SQ FT Range',
                  render: ({ item: community }) => (<span>{`${numeral(get(community, 'sqftLow')).format('0,0')} to ${numeral(get(community, 'sqftHigh')).format('0,0')}`}</span>),
                },
                {
                  title: 'Schools',
                  render: ({ item: community }) => (<span><SchoolList schools={get(community, 'schools', [])} /></span>),
                },
                {
                  title: 'Community Photos',
                  render: ({ item: community }) => (
                    <LightBox
                      items={get(community, 'photos')}
                      button={(<span>{community.photos.length}</span>)}
                    />
                  ),
                },
                {
                  title: 'Virtual Tour',
                  render: ({ item: community }) => (<span>{get(community, 'tour_url') ? 'Yes' : 'No'}</span>),
                },
                {
                  title: 'Video',
                  render: ({ item: community }) => (<span>{get(community, 'videos', []).length ? 'Yes' : 'No'}</span>),
                },
                {
                  title: 'PDF Brochure',
                  render: ({ item: community }) => (<span>{get(community, 'brochure') ? 'Yes' : 'No'}</span>),
                },
                {
                  title: 'Model Address',
                  render: ({ item: community }) => (
                    <div>
                      {get(community, 'address.streetAddress', '')} <br />
                      {`${get(community, 'address.addressLocality', '')}, ${get(community, 'address.addressRegion', '')} ${get(community, 'address.postalCode', '')}`}
                    </div>
                  ),
                },
                {
                  title: 'Quick Move-In Homes',
                  render: ({ homes = [] }) => (<span>{homes.length}</span>),
                },
                {
                  title: 'Floor Plans',
                  render: ({ plans = [] }) => (
                    <div>
                      {plans.length}
                      <div>
                        {
                          plans.map((plan, index) => (
                            <Link className="Compare_planLink" name="plan-detail" plan={plan}>{plan.name}{index !== plans.length - 1 ? ',' : ''}</Link>
                          ))
                        }
                      </div>
                    </div>
                  ),
                },
              ],
            },
            homes: {
              title: 'Homes',
              fields: [
                {
                  title: 'Home',
                  render: ({ item: home, index, toggle }) => (
                    <div>
                      <span className="Compare_itemNumber">#{index + 1}</span>
                      <span className="Compare_itemToggle" role="button" tabIndex="0" onClick={toggle} />
                      <div className="Compare_image CompareCommunity_image">
                        <img src={buildThumbnailUrl(get(home, 'photos[0].contentUrl'))} alt="" style={{ maxWidth: '100%' }} />
                      </div>
                      <Link className="Compare_homeLink" name="home-detail" home={home}>{get(home, 'address.streetAddress')}</Link>
                    </div>
                  ),
                },
                {
                  title: 'Address',
                  render: ({ item: home }) => (
                    <div>
                      {get(home, 'address.streetAddress', [])} <br />
                      {`${get(home, 'address.addressLocality', [])}, ${get(home, 'address.addressRegion', [])} ${get(home, 'address.postalCode', [])}`}
                    </div>
                  ),
                },
                {
                  title: 'Floor Plan',
                  render: ({ plan }) => {
                    if (!plan) {
                      return null;
                    }
                    return (
                      <Link className="Compare_planLink" name="plan-detail" plan={plan}>{get(plan, 'name')}</Link>
                    );
                  },
                },
                {
                  title: 'Headline',
                  render: ({ item: home }) => (<span>{get(home, 'headline')}</span>),
                },
                {
                  title: 'Description',
                  render: ({ item: home }) => (<Truncate value={get(home, 'description')} nl2br />),
                },
                {
                  title: 'Price',
                  render: ({ item: home }) => (<span>{`${numeral(get(home, 'price')).format('$0,0')}`}</span>),
                },
                {
                  title: 'SQ FT',
                  render: ({ item: home }) => (<span>{`${numeral(get(home, 'sqft')).format('0,0')}`}</span>),
                },
                {
                  title: 'Schools',
                  render: ({ community }) => (<span><SchoolList schools={get(community, 'schools', [])} /></span>),
                },
                {
                  title: 'Photos',
                  render: ({ item: home }) => (
                    <LightBox
                      items={get(home, 'photos')}
                      button={(<span>{home.photos.length}</span>)}
                    />
                  ),
                },
                {
                  title: 'Virtual Tour',
                  render: ({ item: home }) => (<span>{get(home, 'tour_url') ? 'Yes' : 'No'}</span>),
                },
                {
                  title: 'Video',
                  render: ({ item: home }) => (<span>{get(home, 'videos[0].video.contentUrl', []).length ? 'Yes' : 'No'}</span>),
                },
                {
                  title: 'PDF Brochure',
                  render: ({ item: home }) => (<span>{get(home, 'brochure.contentUrl') ? 'Yes' : 'No'}</span>),
                },
              ],
            },
            plans: {
              title: 'Plans',
              fields: [
                {
                  title: 'Plan',
                  render: ({ item: plan, index, toggle }) => (
                    <div>
                      <span className="Compare_itemNumber">#{index + 1}</span>
                      <span className="Compare_itemToggle" role="button" tabIndex="0" onClick={toggle} />
                      <div className="Compare_image CompareCommunity_image">
                        <img src={buildThumbnailUrl(get(plan, 'photos[0].contentUrl'))} alt="" style={{ maxWidth: '100%' }} />
                      </div>
                      <Link className="Compare_homeLink" name="plan-detail" plan={plan}>{get(plan, 'name')}</Link>
                    </div>
                  ),
                },
                {
                  title: 'Headline',
                  render: ({ item: home }) => (<span>{get(home, 'headline')}</span>),
                },
                {
                  title: 'Description',
                  render: ({ item: home }) => (<Truncate value={get(home, 'description')} nl2br />),
                },
                {
                  title: 'Price',
                  render: ({ item: home }) => (<span>{`${numeral(get(home, 'price')).format('$0,0')}`}</span>),
                },
                {
                  title: 'SQ FT',
                  render: ({ item: home }) => (<span>{`${numeral(get(home, 'sqft')).format('0,0')}`}</span>),
                },
                {
                  title: 'Photos',
                  render: ({ item: home }) => (
                    <LightBox
                      items={get(home, 'photos')}
                      button={(<span>{home.photos.length}</span>)}
                    />
                  ),
                },
                {
                  title: 'Virtual Tour',
                  render: ({ item: home }) => (<span>{get(home, 'virtual_tour') ? 'Yes' : 'No'}</span>),
                },
                {
                  title: 'Video',
                  render: ({ item: home }) => (<span>{get(home, 'video', []).length ? 'Yes' : 'No'}</span>),
                },
                {
                  title: 'PDF Brochure',
                  render: ({ item: home }) => (<span>{get(home, 'brochure') ? 'Yes' : 'No'}</span>),
                },
              ],
            },
          }}
        />
      }
    </PageWrapper>
  );
}

Compare.propTypes = {
  builder: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  compare: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
    page: 'compare',
    compare: true,
  },
  {
    ifMissing404: true,
  },
)(Compare);



// WEBPACK FOOTER //
// ./src/pages/Compare/index.js